import React, { useEffect, useState } from 'react';
import supabase from '../../services/supabase';

export default function SimpleLeaderboard({ limit = 5, timeframe = 'all' }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setError('');
        setLoading(true);

        // Timeframe bounds
        const now = new Date();
        let start = new Date(2000, 0, 1);
        if (timeframe === 'daily') start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        else if (timeframe === 'weekly') {
          const d = now.getDay();
          start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - d);
        } else if (timeframe === 'monthly') start = new Date(now.getFullYear(), now.getMonth(), 1);

        // Fetch posts (public read required by RLS)
        const { data: posts, error: postsErr } = await supabase
          .from('posts')
          .select('id, user_id, created_at')
          .gte('created_at', start.toISOString())
          .order('created_at', { ascending: false })
          .limit(1000);
        if (postsErr) throw postsErr;

        // Count posts by user
        const counts = new Map();
        (posts || []).forEach(p => {
          counts.set(p.user_id, (counts.get(p.user_id) || 0) + 1);
        });

        const ranked = [...counts.entries()]
          .sort((a, b) => b[1] - a[1])
          .slice(0, limit);

        const topUserIds = ranked.map(([uid]) => uid);
        if (topUserIds.length === 0) {
          if (active) setRows([]);
          return;
        }

        // Fetch minimal profiles (public read required by RLS)
        const { data: profiles, error: profileErr } = await supabase
          .from('user_profiles')
          .select('user_id, username, profilePicture')
          .in('user_id', topUserIds);
        if (profileErr) throw profileErr;

        const profileById = new Map((profiles || []).map(p => [p.user_id, p]));

        const rowsData = ranked.map(([uid, count], i) => ({
          rank: i + 1,
          count,
          profile: profileById.get(uid) || { user_id: uid, username: 'Anonymous' },
        }));

        if (active) setRows(rowsData);
      } catch (e) {
        console.error('SimpleLeaderboard error:', e);
        if (active) setError('');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [limit, timeframe]);

  if (loading) return (
    <div className="leaders-list">
      {Array.from({ length: Math.min(limit, 5) }).map((_, i) => (
        <div key={i} className="leader-row skeleton" />
      ))}
    </div>
  );

  if (!rows || rows.length === 0) return (
    <div className="leaders-empty">No activity yet.</div>
  );

  return (
    <div className="leaders-list">
      {rows.map(r => (
        <button key={r.profile.user_id} className="leader-row" onClick={() => window.location.assign(`/profile/${r.profile.username || ''}`)}>
          <span className="leader-rank">{r.rank}</span>
          {r.profile.profilePicture ? (
            <img className="leader-avatar" src={r.profile.profilePicture} alt={r.profile.username || 'user'} />
          ) : (
            <div className="leader-avatar placeholder">{(r.profile.username || '?').charAt(0).toUpperCase()}</div>
          )}
          <span className="leader-name">{r.profile.username || 'Anonymous'}</span>
          <span className="leader-posts">{r.count} posts</span>
        </button>
      ))}
    </div>
  );
}



